import { IFilterOptions } from "../useAssetTree";
import OptionsTreeWithUngrouped, { IOptionsTreeConfig } from "./sharedTree";

interface IBranchTree {
  filterOptions: IFilterOptions;
  selectedBranches: string[];
  setSelectedBranches: (items: string[]) => void;
  includeNullBranch: boolean;
  setIncludeNullBranch: (value: boolean) => void;
}

const BRANCH_TREE_CONFIG: IOptionsTreeConfig = {
  groupId: "branches",
  ungroupedGroupId: "branches-desagrupado",
  ungroupedItemId: "__desagrupado_branch__",
  itemType: "building",
  icon: "rioglyph rioglyph-building",
  groupLabel: "assetTree.branch.group",
  ungroupedItemLabel: "assetTree.branch.noItem",
  searchPlaceholder: "assetTree.branch.search",
};

const BranchTree = ({
  filterOptions,
  selectedBranches,
  setSelectedBranches,
  includeNullBranch,
  setIncludeNullBranch,
}: IBranchTree) => (
  <OptionsTreeWithUngrouped
    config={BRANCH_TREE_CONFIG}
    options={filterOptions?.branches}
    selectedIds={selectedBranches}
    setSelectedIds={setSelectedBranches}
    includeNull={includeNullBranch}
    setIncludeNull={setIncludeNullBranch}
  />
);

export default BranchTree;
